import { useShallow } from 'zustand/react/shallow';
import useAppStore from '..';

export const useAuth = () =>
  useAppStore(
    useShallow((state) => ({
      user: state.auth.user,
      isLoading: state.auth.isLoading,
      error: state.auth.error,
      setUser: state.setUser,
      logout: state.logout,
      updateUser: state.updateUser,
      setLoading: state.setLoading,
      setError: state.setError,
    }))
  );
